var defaultStyles = {
  "multiple_xs": "Base-Select--MultipleXs",
  "root": "Base-Select",
  "native_root": "Base-Select--NativeRoot",
  "view_with_prefix": "Base-Select--ViewWithPrefix",
  "xs": "Base-Select--Xs",
  "multiple_sm": "Base-Select--MultipleSm",
  "sm": "Base-Select--Sm",
  "multiple_md": "Base-Select--MultipleMd",
  "md": "Base-Select--Md",
  "multiple_lg": "Base-Select--MultipleLg",
  "lg": "Base-Select--Lg",
  "clear": "Base-Select--Clear",
  "link": "Base-Select--Link",
  "native_wrapper": "Base-Select--NativeWrapper",
  "arrow": "Base-Select--Arrow",
  "native_arrow": "Base-Select--NativeArrow",
  "arrow_has_border": "Base-Select--ArrowHasBorder",
  "pointers": "Base-Select--Pointers",
  "pointer": "Base-Select--Pointer",
  "input": "Base-Select--Input",
  "has_label": "Base-Select--HasLabel",
  "value": "Base-Select--Value",
  "active": "Base-Select--Active",
  "label": "Base-Select--Label",
  "focused": "Base-Select--Focused",
  "label_active": "Base-Select--LabelActive",
  "disabled": "Base-Select--Disabled",
  "multiple": "Base-Select--Multiple",
  "show_search": "Base-Select--ShowSearch",
  "input_wrapper": "Base-Select--InputWrapper",
  "input_inner": "Base-Select--InputInner",
  "input_default": "Base-Select--InputDefault",
  "input_focus": "Base-Select--InputFocus",
  "hidden": "Base-Select--Hidden",
  "error": "Base-Select--Error",
  "success": "Base-Select--Success",
  "warning": "Base-Select--Warning",
  "prefix": "Base-Select--Prefix",
  "suffix": "Base-Select--Suffix",
  "open": "Base-Select--Open",
  "popover": "Base-Select--Popover",
  "list": "Base-Select--List",
  "option": "Base-Select--Option",
  "option_wrapper": "Base-Select--OptionWrapper",
  "option_disabled": "Base-Select--OptionDisabled",
  "option_selected": "Base-Select--OptionSelected",
  "option_default": "Base-Select--OptionDefault",
  "option_hover": "Base-Select--OptionHover",
  "option_empty": "Base-Select--OptionEmpty",
  "option_content": "Base-Select--OptionContent",
  "option_highlight": "Base-Select--OptionHighlight",
  "select_checkbox": "Base-Select--SelectCheckbox",
  "option_group_title": "Base-Select--OptionGroupTitle"
};

export { defaultStyles as default };
